import { render } from "./OrganizationSetupWizard.vue?vue&type=template&id=5b0245a6&scoped=true"
import script from "./OrganizationSetupWizard.vue?vue&type=script&lang=js"
export * from "./OrganizationSetupWizard.vue?vue&type=script&lang=js"

import "./OrganizationSetupWizard.vue?vue&type=style&index=0&id=5b0245a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0245a6"]])

export default __exports__